import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';

// Customize value container
const MultiSelectValueContainer: FC = (valueProps: any) => {
  const { t } = useTranslation();
  const { children, getValue, selectProps } = valueProps;
  const { showTotal: showTotalProp } = selectProps;
  const currentValues = getValue();
  const { length } = currentValues;
  if (showTotalProp && length)
    return (
      <components.ValueContainer {...valueProps}>
        {t('form.selected', { count: length })}
        {React.cloneElement(children[1])}
      </components.ValueContainer>
    );

  return <components.ValueContainer {...valueProps} />;
};

export default MultiSelectValueContainer;
